import './SuggestionField.scss';
import classNames from 'classnames';
import { CloseCircleOutlined } from '@ant-design/icons';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { haltClickEventPropagation } from '@lib/events';
import { Button, Skeleton } from 'antd';
import { Case, Default, Switch, When } from 'react-if';
import { OutsideClickWrapper, SuggestionButton } from '@ui/general';
import React, { useCallback } from 'react';
export const SuggestionField = ({ autodocType, children, isSpreadsheet, onAccept, onEdit, onBlur, placeholder, suggestion }) => {
    var _a;
    const handleClick = useCallback(() => {
        suggestion.request();
    }, [suggestion]);
    const handleSuggestionClick = useCallback((e) => {
        e.stopPropagation();
        e.preventDefault();
        onEdit();
    }, [onEdit]);
    const handleAcceptClick = useCallback((e) => {
        e.stopPropagation();
        e.preventDefault();
        onAccept();
    }, [onAccept]);
    return (React.createElement(OutsideClickWrapper, { className: 'suggest-field', onClick: suggestion.loading ? haltClickEventPropagation : handleSuggestionClick, onClickOutside: onBlur },
        React.createElement(When, { condition: !suggestion.isEditing },
            React.createElement("div", { className: classNames('suggestion-overlay', {
                    error: suggestion.hasError,
                    spreadsheet: isSpreadsheet
                }) },
                React.createElement(Switch, null,
                    React.createElement(Case, { condition: suggestion.loading },
                        React.createElement(Skeleton.Input, { active: true })),
                    React.createElement(Case, { condition: suggestion.value },
                        React.createElement("div", { className: 'suggestion-preview' },
                            React.createElement("div", { className: 'suggestion-text', onClick: handleSuggestionClick }, (_a = suggestion.value) === null || _a === void 0 ? void 0 : _a.split(' ').map((word, index) => {
                                const key = `${word}${index}`;
                                return React.createElement("span", { key: key }, word);
                            })),
                            React.createElement("div", { className: 'accept-suggestion' },
                                COPY_SPECIFIC.UNSAVED_SUGGESTION,
                                React.createElement(Button, { onClick: handleAcceptClick, type: 'link' }, COPY_SPECIFIC.ACCEPT)))),
                    React.createElement(Default, null,
                        React.createElement(When, { condition: isSpreadsheet },
                            React.createElement(SuggestionButton, { autodocType: autodocType, onClick: handleClick })),
                        React.createElement(When, { condition: placeholder },
                            React.createElement("span", { className: 'placeholder' }, placeholder)))),
                React.createElement(When, { condition: isSpreadsheet },
                    React.createElement("div", { className: 'error-icon' },
                        React.createElement(CloseCircleOutlined, null))))),
        React.createElement("div", { className: classNames('suggestion-editor', { hidden: !suggestion.isEditing }) }, children)));
};
